import Download from '@mui/icons-material/Download';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import useGeneratePdfFromContent from '../../../../hooks/useGeneratePdfFromContent';
import { useContentMetadata } from 'components/editor/hooks/useContentMetadata';
import { ContentType } from 'utils/getContentType';

type PdfDownloadButtonProps = {
  contentId: string;
  fileName: string;
};

const PdfDownloadButtonForShareCard = ({ contentId, fileName }: PdfDownloadButtonProps) => {
  const { data: documentData } = useContentMetadata(ContentType.DOCUMENT, contentId);
  const documentId = documentData?.documentId as string;
  const { t } = useTranslation();
  const { generatePdf, isLoading } = useGeneratePdfFromContent();

  const downloadPdf = async () => {
    await generatePdf({ contentId, documentId, fileName });
  };

  return (
    <span>
      <Button variant="outlined" color="primary" startIcon={<Download />} onClick={downloadPdf} disabled={isLoading}>
        {isLoading ? <CircularProgress size={24} /> : t('share_document_v3.share_card.download_as_pdf')}
      </Button>
    </span>
  );
};

export default PdfDownloadButtonForShareCard;
